<template>
  <div class="viewer">
    <div class="viewer-overlay"></div>
    <div class="viewer-content">
      <div class="image-wrapper" @mousedown="startDrag" @mousemove="drag" @mouseup="endDrag" @mouseleave="endDrag">
        <img ref="image" :src="url" :style="imageStyle" />
      </div>
      <div class="btns">
        <a href="javascript:void(0);" class="close" @click="close"></a>
        <a href="javascript:void(0);" class="bigger" @click="zoomIn"></a>
        <a href="javascript:void(0);" class="smaller" @click="zoomOut"></a>
        <a href="javascript:void(0);" class="rotate" @click="rotateRight"></a>
        <a :href="downFile(url, name)" class="down" target="_blank" :download="name"></a>
      </div>
    </div>
  </div>
</template>

<script>
import { Tacitly } from '@/assets/js/Tacitly'
export default {
  props: {
    url: {
      type: String,
    },
    name: {
      type: String,
    }
  },
  data() {
    return {
      visible: true,
      scale: 1,
      rotation: 0,
      isDragging: false,
      startX: 0,
      startY: 0,
      translateX: 0,
      translateY: 0,
      lastTranslateX: 0,
      lastTranslateY: 0,
    };
  },
  computed: {
    imageStyle() {
      return {
        transform: `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale}) rotate(${this.rotation}deg)`,
        cursor: this.isDragging ? 'grabbing' : 'grab',
        transition: this.isDragging ? 'none' : 'transform 0.1s ease',
      };
    },
  },
  methods: {
    close() {
      //this.visible = false;
      this.$emit('close')
    },
    rotateLeft() {
      this.rotation -= 90;
    },
    rotateRight() {
      this.rotation += 90;
    },
    zoomIn() {
      this.scale = Math.min(this.scale + 0.1, 3); // Limit zoom in
    },
    zoomOut() {
      this.scale = Math.max(0.1, this.scale - 0.1); // Limit zoom out
    },
    startDrag(event) {
      this.isDragging = true;
      this.startX = event.clientX - this.lastTranslateX;
      this.startY = event.clientY - this.lastTranslateY;
    },
    drag(event) {
      if (this.isDragging) {
        this.translateX = event.clientX - this.startX;
        this.translateY = event.clientY - this.startY;
      }
    },
    endDrag() {
      this.isDragging = false;
      this.lastTranslateX = this.translateX;
      this.lastTranslateY = this.translateY;
    },
    downFile(url, name) {
      const baseUrl = process.env.NODE_ENV == "development" ? "https://demo.dyuit.cn/xiaoyin/index.php/api/" : Tacitly.Base_Port;
      return `${baseUrl}common/download?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(name)}`
    },
  },
};
</script>

<style lang="less" scoped>
.viewer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.btns {
  position: absolute;
  width: 60px;
  right: 40px;
  top: 20px;
  height: 100%;
  z-index: 1111111;

  a {
    width: 60px;
    height: 60px;
    display: block;
    background-repeat: no-repeat;
    background-size: 40px 40px;
    background-position: center center;
    cursor: pointer;
  }

  .bigger {
    background-image: url("../../assets/img/max1.png");
  }

  .smaller {
    background-image: url("../../assets/img/max2.png");
  }

  .rotate {
    background-image: url("../../assets/img/rotate.png");
  }

  .close {
    background-image: url("../../assets/img/close.png");
  }

  .down {
    background-image: url("../../assets/img/download.png");
  }
}

.viewer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
}

.viewer-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
}

img {
  max-width: 100%;
  max-height: 100%;
  user-select: none;
  pointer-events: none;
}

.viewer-controls {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}

.viewer-controls button {
  padding: 8px 15px;
  background-color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.viewer-controls button:hover {
  background-color: #f0f0f0;
}
</style>
